import React, { useEffect } from "react";
import { DateInput } from "semantic-ui-calendar-react";
import useComplianceView from "@hooks/useComplianceView";
import useComplianceSummaryFilters from "@hooks/useComplianceSummaryFilters";

const PeriodFilters = () => {
  const { isLoading, operator, hasSelection } = useComplianceView();

  const { onChange, getMetaData, startDate, endDate } =
    useComplianceSummaryFilters();

  useEffect(getMetaData, [operator, hasSelection]);

  const fields = [
    {
      name: "startDate",
      label: "From",
      value: startDate,
    },
    {
      name: "endDate",
      label: "To",
      value: endDate,
    },
  ];

  return (
    <>
      {fields.map(({ name, label, value }, index) => {
        return (
          <DateInput
            key={`${name}_${index}`}
            width={3}
            label={`${label}:`}
            name={name}
            value={value}
            iconPosition="left"
            onChange={onChange}
            dateFormat="YYYY-MM-DD"
            animation="fade"
            popupPosition="bottom center"
            disabled={!hasSelection || isLoading}
            closable
            autoComplete="off"
          />
        );
      })}
    </>
  );
};

export default PeriodFilters;
